import styled from 'styled-components';

export const Container = styled.div`
  .table {
    border-radius: 5px;
  }
  p {
    color: #354153;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
  }

  td {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: ${(props) => props.theme.$black};
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }

  th {
    text-align: center;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: ${(props) => props.theme.$black} !important;
  }
`;
